// extracted by mini-css-extract-plugin
export default {"skeleton":"UserSkeleton_skeleton__ZIMC+"};